import { __extends } from "tslib";
import { User } from '../User';
var OidcUser = /** @class */ (function (_super) {
    __extends(OidcUser, _super);
    function OidcUser(userData) {
        var _this = _super.call(this, userData.profile.name, userData.profile.preferred_username, userData.profile.given_name, userData.profile.family_name) || this;
        _this.userData = userData;
        return _this;
    }
    Object.defineProperty(OidcUser.prototype, "hasExpired", {
        get: function () {
            return this.userData.expired;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(OidcUser.prototype, "authKey", {
        get: function () {
            return this.userData.token_type + " " + this.userData.access_token;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(OidcUser.prototype, "accessToken", {
        get: function () {
            return this.userData.access_token;
        },
        enumerable: false,
        configurable: true
    });
    return OidcUser;
}(User));
export default OidcUser;
